import styles from "../pages/pages.module.scss";
import { reportsec, } from "../utils/assets";

const AIAccountingCard = () => {

    return (
        <>
            {/* <div className={styles.toolaHReal}> */}
            <div className={styles.title}>
                <p>Create Report <span>For May 2024</span></p>
            </div>
            {reportsec.map((item, index) => (
                <div className={styles.reportItem} key={index}>
                    <div className={styles.cntr}>
                        <img
                            src={item.icon}
                            alt={`${item.text} icon`}
                            className="icon"
                        />

                        <p className="text">{item.text}</p>
                    </div>
                    <img
                        src={item.src}
                        alt="tick circle"
                        className={styles.tickcircle}
                    />
                </div>
            ))}{" "}
            {/* </div> */}
        </>
    )
}

export default AIAccountingCard;